import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageRoutingModule } from './page-routing.module';
import { PresentationComponent } from './presentation/presentation.component';
import { PrestationComponent } from './prestation/prestation.component';
import { EquipeComponent } from './equipe/equipe.component';
import { MaterielComponent } from './materiel/materiel.component';
import { ReferenceComponent } from './reference/reference.component';
import { GalerieComponent } from './galerie/galerie.component';
import { ContactComponent } from './contact/contact.component';
import { AccueilComponent } from './accueil/accueil.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProgrammationComponent } from './programmation/programmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [PresentationComponent, PrestationComponent, EquipeComponent, MaterielComponent, ReferenceComponent, GalerieComponent, ContactComponent, AccueilComponent, PageNotFoundComponent, ProgrammationComponent],
  imports: [
    CommonModule,
    PageRoutingModule,
    FormsModule,
    ReactiveFormsModule

  ]
})
export class PageModule { }
